import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-sans_line bg-sans_bone mt-24 md:mt-32">
      <div className="sans-container py-16 md:py-20 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <div className="font-serif text-2xl md:text-3xl text-sans_ink tracking-tight">Saans Ayurved</div>
          <p className="sans-body mt-4 max-w-sm">
            Authentic classical Ayurveda, made personal. Rooted in tradition, delivered thoughtfully.
          </p>
        </div>
        <div>
          <div className="sans-label mb-4">Explore</div>
          <ul className="space-y-2.5">
            <li><Link to="/assessment" className="text-sm text-sans_ink hover:opacity-70">Prakriti Assessment</Link></li>
            <li><Link to="/consultation" className="text-sm text-sans_ink hover:opacity-70">Book Consultation</Link></li>
            <li><Link to="/products" className="text-sm text-sans_ink hover:opacity-70">Products</Link></li>
            <li><Link to="/learn" className="text-sm text-sans_ink hover:opacity-70">Learn</Link></li>
          </ul>
        </div>
        <div>
          <div className="sans-label mb-4">Saans Ayurved</div>
          <ul className="space-y-2.5">
            <li><Link to="/about" className="text-sm text-sans_ink hover:opacity-70">About</Link></li>
            <li><Link to="/founder" className="text-sm text-sans_ink hover:opacity-70">Founder</Link></li>
            <li><Link to="/clinical-evidence" className="text-sm text-sans_ink hover:opacity-70">Clinical Evidence</Link></li>
            <li><a className="text-sm text-sans_ink hover:opacity-70" href="mailto:hello@sansayurved.com">Contact</a></li>
            <li><a className="text-sm text-sans_ink hover:opacity-70" href="#">Privacy</a></li>
            <li><a className="text-sm text-sans_ink hover:opacity-70" href="#">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-sans_line">
        <div className="sans-container py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-sans_mute">© {new Date().getFullYear()} Saans Ayurved. All rights reserved.</div>
          <div className="text-xs text-sans_mute">Educational Ayurvedic content. Not a substitute for professional medical advice.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
